export default __webpack_public_path__ + "static/media/XSYN Stack White.8d6370e4.svg";